import { Controller } from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import ListItem from "@mui/material/ListItem";

export const RHFAutocompleteField = ({
  name,
  label,
  options,
  optionIdentifiers,
  control,
  validationHelper,
  rules,
  viewMode,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const { onChange, value, ref } = field;
        return (
          <Autocomplete
            disabled={viewMode}
            value={
              value
                ? options.find((option) => {
                    return value === option[optionIdentifiers.id];
                  })
                : null
            }
            getOptionLabel={(option) => option[optionIdentifiers.label]}
            // getOptionLabel={(option) =>
            //   `${option[optionIdentifiers.label]} (${
            //     option[optionIdentifiers.id]
            //   })`
            // }
            onChange={(event, newValue) => {
              onChange(newValue ? newValue[optionIdentifiers.id] : null);
            }}
            id={`${name}-autocomplete`}
            options={options}
            renderInput={(params) => (
              <TextField
                // sx={{ ml: Number(indentation) }}
                {...params}
                label={label}
                inputRef={ref}
                //   error={!!error}
                error={error !== undefined}
                helperText={error ? validationHelper[name][error.type] : ""}
              />
            )}
            renderOption={(props, option) => (
              <ListItem
                sx={{
                  ml: Number(option?.indentation),
                  fontWeight: !Number(option?.indentation) && "medium",
                }}
                {...props}
              >
                {option[optionIdentifiers.label]}
              </ListItem>
            )}

            // groupBy={(option) => option?.indentation}
          />
        );
      }}
    />
  );
};
